import { Dispatch } from "redux";
import { AlertModel } from "../models/alertModel";
import { AppState } from "../reducers/rootReducer";
import { AppActions, EDIT_ALERT, SET_ALERT } from "../types/actions";

export const setAlert = (alert : AlertModel) : AppActions => ({
    type: SET_ALERT,
    alert
});

export const editAlert = (alert: AlertModel) : AppActions => ({
    type: EDIT_ALERT,
    alert
});

// start editing protoype variables 

export const startEditAlert = (alert: AlertModel) => {
    return (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        dispatch(editAlert(alert));
    };
};

// start set all session data 

export const startSetAlert = (alert: AlertModel) => {
    return( dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        dispatch(setAlert(alert));
    }
}